module.exports = __webpack_public_path__ + "img/jg03-a1c802.jpg";